import { render, staticRenderFns } from "./tab-tabs.vue?vue&type=template&id=ad86fd4c&scoped=true"
import script from "./tab-tabs.vue?vue&type=script&lang=js"
export * from "./tab-tabs.vue?vue&type=script&lang=js"
import style0 from "./tab-tabs.vue?vue&type=style&index=0&id=ad86fd4c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad86fd4c",
  null
  
)

export default component.exports